module.exports = __webpack_public_path__ + "img/schema_installation_en_local.428bab29.jpg";